export const limitCSVToRows = async(file: File, maxRows: number = 500): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const text = e.target?.result as string;
        const lines = text.split('\n');

        // Keep header (first line) + up to maxRows data rows
        const header = lines[0];
        const dataRows = lines.slice(1).filter(line => line.trim() !== '');
        const limitedRows = dataRows.slice(0, maxRows);

        const limitedContent = [header, ...limitedRows].join('\n');

        const limitedFile = new File([limitedContent], file.name, {
          type: file.type || 'text/csv',
          lastModified: Date.now(),
        });

        resolve(limitedFile);
      } catch (error) {
        reject(new Error('Failed to process CSV file'));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};
